import React from 'react'
// import * as FcIcons from 'react-icons/fc'
import * as AiIcons from 'react-icons/ai'
import * as IoIcons from 'react-icons/io5'


export const SideBarData = [
    {
        title: "Home",
        path: "/documents",
        icon: <AiIcons.AiFillHome />,
        cName: "side-text"
    },
    {
        title: "New",
        path: "/",
        icon: <AiIcons.AiOutlineFileAdd />,
        cName: "side-text"
    },
    {
        title: "Open",
        path: "#",
        icon: <AiIcons.AiOutlineFolderOpen />,
        cName: "side-text"
    },
    {
        title: "Export",
        path: "#",
        icon: <AiIcons.AiOutlineExport />,
        cName: "side-text"
    },
    {
        title: "Teams",
        path: "#",
        icon: <AiIcons.AiOutlineTeam />,
        cName: "side-text"
    },
    {
        title: "Share",
        path: "#",
        icon: <IoIcons.IoShareSocialOutline />,
        cName: "side-text"
    },
    {
        title: "About",
        path: "/about",
        icon: <AiIcons.AiOutlineInfoCircle />,
        cName: "side-text"
    },
]
